module.exports = __webpack_public_path__ + "img/gif-owvoices-new.71bc38b5.gif";